import { useEffect, useState } from "react";
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table";
import { useTheme } from "@table-library/react-table-library/theme";

export const ContainerTable = ({ data, columns }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const currentData = { nodes: data };

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const theme = useTheme({
    Table: `
      grid-template-columns: repeat(${columns.length}, minmax(200px, 1fr));
      border-radius: 10px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom-right-radius: "10px";
      border: none;
      box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.10);
      margin-top: -5px;
      `,
    HeaderCell: `
      border: none;
      `,
    BaseCell: `
        &:nth-of-type(1) {
          left: 0px;
        }
        &:not(:last-of-type) {
          border-bottom: 1px solid #EDEDED;
          border-right: none;
        }
      `,
  });

  return (
    <Table
      data={currentData}
      theme={theme}
      layout={{ custom: true, horizontalScroll: true }}
    >
      {(tableList) => (
        <>
          <Header>
            <HeaderRow>
              {columns.map((column, i) => {
                let pinLeft = false;
                let boxShadow = false;
                if (column.label.toLowerCase() === "service days") {
                  pinLeft = true;
                  boxShadow = true;
                }

                return (
                  <HeaderCell
                    pinLeft={pinLeft}
                    key={i}
                    className={`table-header ${
                      boxShadow && windowWidth < 768 ? "shadow-table" : ""
                    }`}
                  >
                    {column.label}
                  </HeaderCell>
                );
              })}
            </HeaderRow>
          </Header>
          <Body>
            {tableList.map((item) => (
              <Row key={item.id} item={item}>
                {columns.map((column, i) => {
                  let pinLeft = false;
                  let boxShadow = false;
                  if (column.label.toLowerCase() === "service days") {
                    pinLeft = true;
                    boxShadow = true;
                  }
                  return (
                    <Cell
                      className={`table-cell ${
                        item.id.startsWith("bg")
                          ? "cell-bg-secondary text-gray-900 text-16-md p-8-16"
                          : "text-gray-700 text-13-md p-24-16"
                      } ${
                        boxShadow && windowWidth < 768 ? "shadow-table" : ""
                      }`}
                      pinLeft={pinLeft}
                    >
                      {column.renderCell(item)}
                    </Cell>
                  );
                })}
              </Row>
            ))}
          </Body>
        </>
      )}
    </Table>
  );
};
